export default __webpack_public_path__ + "static/media/lumin-min.c876698e.png";